//* Seller(꽃집) 정산 내역 페이지 전용 atom (미정산 + 정산완료)

import { atom } from 'recoil';

import { QueryStatus } from 'react-query';

import {
  SellerMonthlyAccountedResponse,
  SellerNeedAccountResponse,
} from './needAccount.interface';

// ── Seller 미정산 내역 (NeedAccount) ──

export const sellerNeedAccountStatusAtom = atom<QueryStatus>({
  key: 'sellerNeedAccountStatusAtom',
  default: 'idle',
});

export const sellerNeedAccountDataAtom = atom<SellerNeedAccountResponse | null>({
  key: 'sellerNeedAccountDataAtom',
  default: null,
});

// ── Seller 정산완료 내역 (MonthlyAccounted) ──

export const sellerMonthlyAccountedStatusAtom = atom<QueryStatus>({
  key: 'sellerMonthlyAccountedStatusAtom',
  default: 'idle',
});

export const sellerMonthlyAccountedDataAtom = atom<SellerMonthlyAccountedResponse | null>({
  key: 'sellerMonthlyAccountedDataAtom',
  default: null,
});
